import(/* webpackMode: "eager" */ "/app/apps/home/src/app/global-error.tsx");
